import * as React from 'react';
import moment from 'moment';

import Tooltip from 'components/Tooltip';
import FormRequiredMark from 'components/form/form-required-mark/FormRequiredMark';

import DatePickerMulti from 'components/date-picker/date-picker-multi/DatePickerMultiLazy';

import { __t, applyTranslations } from 'utils/language';
import { HTML_DATE_FORMAT } from 'utils/date';
import {
  TIMEFRAME_NUM_YEARS_IN_FUTURE
} from 'modules/insights/reports/utils/insights-reports';

import './insights-reports-timeframe.scss';

applyTranslations(require('./insights-reports-timeframe.i18n.json'));

type Props = {
  startDate: string | null,
  endDate: string | null,
  withErrorHighlight?: boolean,
  onChange: (startDate: string | null, endDate: string | null) => void
};

const MSG_KEY = 'insights_reports_timeframe';

const InsightsReportsTimeframe: React.FunctionComponent<Props> = ({
  startDate,
  endDate,
  withErrorHighlight,
  onChange
}: Props) => {
  const maxAllowableDate = moment().subtract(TIMEFRAME_NUM_YEARS_IN_FUTURE, 'd').format(HTML_DATE_FORMAT);
  const isInvalidTimeFrame = Boolean(!startDate || !endDate);

  const renderCalendarInfo = (): React.ReactNode => (
    <div className="insights-reports-timeframe__calendar-info">
      {__t(`${MSG_KEY}.message`)}
    </div>
  );

  const renderHeader = (): React.ReactNode => (
    <div className="insights-reports-timeframe__header">
      <div className="insights-reports-timeframe__header-text">
        {__t(`${MSG_KEY}.header`)}
      </div>
      <FormRequiredMark />
      <div className="insights-reports-section-header__tooltip">
        <Tooltip
          message={__t(`${MSG_KEY}.tooltip`)}
          showQuestionMark
        />
      </div>
    </div>
  );

  return (
    <div className="insights-reports-timeframe">
      {renderHeader()}
      <DatePickerMulti
        startDateName="startDate"
        startDate={startDate}
        endDateName="endDate"
        endDate={endDate}
        noPastDates={false}
        numMonths={1}
        numFutureYearsInDateSelector={TIMEFRAME_NUM_YEARS_IN_FUTURE}
        maxAllowableDate={maxAllowableDate}
        calendarInfo={renderCalendarInfo()}
        onChange={onChange}
        noFutureDates
        showDateSelector
      />
      {withErrorHighlight && isInvalidTimeFrame && (
        <div className="insights-reports-timeframe__error">
          {__t(`${MSG_KEY}.error`)}
        </div>
      )}
    </div>
  );
};

export default InsightsReportsTimeframe;
